module.exports = __webpack_public_path__ + "static/brandscape-f55808ffd804f4e1f22aab7cab628497.jpg";